import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import JwtService from "@/core/services/JwtService";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/trader",
    component: () => import("@/components/page-layouts/Logined.vue"),
    children: [
      { path: "/trader", name: "trader", component: () => import("@/views/pesatr/logined/Trader.vue"), },
    ],
  },
  {
    path: "/", component: () => import("@/components/page-layouts/AuthPesatr.vue"),
    children: [
      { path: "/newuser", name: "new-user", component: () => import("@/views/pesatr/user/NewUser.vue"), },
      { path: "/newuserrf/:id", name: "new-user-rf", component: () => import("@/views/pesatr/user/NewUser.vue"), },
      { path: "/signinuser", name: "sign-in-user", component: () => import("@/views/pesatr/user/SignInUser.vue"), },
      { path: "/useractivation/:id", name: "user-activation", component: () => import("@/views/pesatr/user/UserActivation.vue"), },
      { path: "/useractivationsent", name: "user-activation-sent", component: () => import("@/views/pesatr/user/UserActivationSent.vue"), },
      { path: "/passwordforgot", name: "password-forgot", component: () => import("@/views/pesatr/user/PasswordForgot.vue"), },
      { path: "/passwordreset/:id", name: "password-reset", component: () => import("@/views/pesatr/user/PasswordReset.vue"), },
      { path: "/autologout", name: "user-auto-logout", component: () => import("@/views/pesatr/user/AutoLogout.vue"), },
      { path: "/testuser", name: "test-user", component: () => import("@/views/pesatr/user/TestUser.vue"), },
    ],
  },

  {
    path: "/", component: () => import("@/components/page-layouts/DepositLayout.vue"),
    children: [
      { path: "/deposit", name: "user-deposit", component: () => import("@/views/pesatr/logined/Deposit.vue"), },
    ],
  },
  {
    path: "/", component: () => import("@/components/page-layouts/DepositLayout.vue"),
    children: [
      { path: "/transfers", name: "transfer-page", component: () => import("@/views/pesatr/logined/Transfers.vue"), },
    ],
  },
  {
    path: "/", component: () => import("@/components/page-layouts/EmptyLayout.vue"),
    children: [
      { path: "/healthcheck", name: "healthcheck", component: () => import("@/views/pesatr/data/HealthCheck.vue"), },
    ],
  },
  {
    path: "/", component: () => import("@/components/page-layouts/JackpotsLayout.vue"),
    children: [
      { path: "/services/jackpots", name: "services-jackpots", component: () => import("@/views/pesatr/data/Jackpots.vue"), },
    ],
  },
  {
    path: "/", component: () => import("@/components/page-layouts/TestLayout.vue"),
    children: [
      { path: "/testview", name: "test-view", component: () => import("@/views/pesatr/logined/TestView.vue"), },      
    ],
  },
  {
    // the 404 route, when none of the above matches
    path: "/404", name: "404", component: () => import("@/views/crafted/authentication/Error404.vue"),
  },
  { 
    path: "/500", name: "500", component: () => import("@/views/crafted/authentication/Error500.vue"),
  },
  { 
    path: "/:pathMatch(.*)*", redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(() => {
  // reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  store.dispatch(Actions.VERIFY_AUTH, { Authorization: JwtService.getToken(), Username:JwtService.getUserName() });

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

export default router;
